import "../ProductCategoryModal/ProductCategoryModal.scss";
import primaryComponents from "../../primaryComponents";
import Validation from "./useValidation";
import { formatCurrency } from "../../../helpers";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import useWriteOff from "./useWriteOff";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const WriteOffModal = ({
  orderAmount = 0,
  customer,
  closeModal = () => {},
  onSuccess = () => {},
  fetchCustomer = () => {},
}) => {
  const { details, setDetails, handleUpdate, updateWriteOff } = useWriteOff({
    customer,
    closeModal,
    onSuccess,
    fetchCustomer,
  });

  const {
    register,
    formState: { errors },
    trigger,
    control,
    handleSubmit,
  } = Validation(details);

  return (
    <div className="update-credit">
      <FontAwesomeIcon
        onClick={closeModal}
        className="d-block ml-auto"
        icon="times"
        style={{ fontSize: "25px", cursor: "pointer" }}
      />
      <div className="update-credit__title">Write-off</div>
      <div className="update-credit__subtitle">
        Cancel this credit record as a bad debt
      </div>

      <dl className="update-credit__data mt-4">
        <dt className="outstanding">Outstanding Balance</dt>
        <dd
          className="outstanding"
          style={{
            color: customer?.outstanding_balance <= 0 ? "#19AE57" : "#E02020",
          }}
        >
          {formatCurrency({
            value:
              customer?.outstanding_balance <= 0
                ? Math.abs(customer?.outstanding_balance)
                : -Math.abs(customer?.outstanding_balance),
            currencyCode: customer?.store?.currency_code,
          })}
        </dd>

        <dt>Customer Name</dt>
        <dd>{customer?.full_name}</dd>

        <dt>Total Credit</dt>
        <dd>
          {formatCurrency({
            value: customer?.total_credit,
            currencyCode: customer?.store?.currency_code,
          })}
        </dd>

        <dt>Total Payment</dt>
        <dd>
          {formatCurrency({
            value: customer?.total_repayment,
            currencyCode: customer?.store?.currency_code,
          })}
        </dd>

        <dt>Status</dt>
        <dd>
          <span style={{ fontSize: "10px" }} className="success--squared ml-3">
            Active
          </span>
        </dd>
      </dl>

      <div>
        <primaryComponents.InputFieldV2
          name="amount"
          control={control}
          label={"Amount"}
          isRequired={true}
          placeholder="Amount"
          type="number"
          value={details?.amount}
          onChange={({ target: { value } }) =>
            setDetails((prev) => ({ ...prev, amount: value }))
          }
          errorMessage={errors.amount}
          onKeyUp={() => errors.amount !== undefined && trigger("amount")}
          register={register}
        />

        <div className="py-3 px-3 mt-2 border rounded">
          <primaryComponents.DateInputV2
            name="writeOffAt"
            control={control}
            label={"Write-off Date"}
            placeholder="Write-off Date"
            value={details?.write_off_at}
            isRequired
            onChange={({ target: { value } }) =>
              setDetails((prev) => ({ ...prev, write_off_at: value }))
            }
            onKeyUp={() =>
              errors.writeOffAt !== undefined && trigger("writeOffAt")
            }
            errorMessage={errors.writeOffAt}
            register={register}
          />
          <div className="mt-3">
            <primaryComponents.TextAreaV2
              control={control}
              type="text"
              label={"Note"}
              name="note"
              placeholder="Add note for this loan transaction"
              value={details.note}
              onChange={({ target: { value } }) =>
                setDetails((prev) => ({ ...prev, note: value }))
              }
              register={register}
            />
          </div>
        </div>
      </div>

      <div className={`${globalStyles.stickyBottomCover} mt-3`}>
        <primaryComponents.Button
          classNames="btn btn--primary cover"
          isLoading={updateWriteOff.isLoading}
          loadingText="Updating..."
          isDisabled={updateWriteOff.isLoading}
          onClick={handleSubmit(handleUpdate)}
        >
          Update
        </primaryComponents.Button>
      </div>
    </div>
  );
};
export default WriteOffModal;
